export default {
    setUserTimezone(state, timezone) {
        state.userTimezone = timezone;
    },
    setEvents(state, events) {
        state.events = events;
    },
    setEvent(state, event) {
        state.events.push(event);
    },
    setTimeZones(state, timeZones) {
        state.timeZones = timeZones;
    },
    deleteEvent(state, eventId) {
        let index = state.events.findIndex(item => item.id == eventId);
        state.events.splice(index, 1);
    },
    updateEvent(state, event) {
        const elementsIndex = state.events.findIndex(item => item.id == event.id);
        if (event.startTime) {
            delete event.startTime;
        }
        if (event.endTime) {
            delete event.endTime;
        }
        state.events[elementsIndex] = event;
    },
    updateAppointment(state, { event, data }) {
        const elementsIndex = state.events.findIndex(item => item.id == event.id);
        for (const [key, value] of Object.entries(data)) {
            state.events[elementsIndex][key] = value;
        }
    },
    updateMeetingToEvent(state, { event_id, meeting }) {
        let event = state.events.find(item => item.id == event_id);
        if (event) {
            event.meeting = meeting;
        }
    },
    setEventTemplate(state, event) {
        state.events.push(event);
    },
    updateEventTemplate(state, { templateId, data }) {
        const templateIndex = state.events.findIndex(item => item.templateId == templateId);
        state.events[templateIndex].id = data.id;
        state.events[templateIndex].start = data.start;
        state.events[templateIndex].end = data.end;
        state.events[templateIndex].isMidnight = data.isMidnight;
        state.events[templateIndex].created_at = data.created_at;
        state.events[templateIndex].updated_at = data.updated_at;
        state.events[templateIndex].timed = data.timed;
        state.events[templateIndex].type_id = data.type_id;
        state.events[templateIndex].color = data.color.name;
    },
    deleteEventTemplate(state, templateId) {
        const templateIndex = state.events.findIndex(item => item.templateId == templateId);
        state.events.splice(templateIndex, 1);
    },
    deleteEventByIndex(state, index) {
        state.events.splice(index, 1);
    },
    popEvent(state) {
        state.events.pop();
    },
    updateEventStartEnd(state, { start, end, isMidnight, event }) {
        if (start != null) {
            event.start = start;
        }

        if (end != null) {
            event.end = end;
        }

        if (isMidnight != null) {
            event.isMidnight = isMidnight;
        }
    },
    updateSlots (state, timeSlots) {
        state.timeSlots = timeSlots
    },
    addNewSlot (state, timeSlots) {
        state.timeSlots.push(timeSlots)
    },
    updateCustomSlots (state, timeSlots) {
        state.customTimeSlots = timeSlots
    },
    addCustomSlot(state, slot){
        state.customTimeSlots.push(slot)
    },
    removeCustomSlot(state, index){
        state.customTimeSlots.splice(index, 1)
    },
    updateAppointments (state, appointments) {
        state.appointments = appointments
    },
    updateAvailabilities (state, availabilities) {
        state.availabilities = availabilities
    },
    updateBlockTime(state, time){
        state.blockTime = time
    },
    setOverlapError(state, message) {
        state.overlapError = message;
    },
    clearOverlapError(state) {
        state.overlapError = null;
    },
    setDeleteError(state, message) {
        state.deleteError = message;
    },
    clearDeleteError(state) {
        state.deleteError = null;
    },
}
